import React, { useCallback, useState } from 'react';
import { Button } from '../common';
import { MenuContainer } from '../menu/MenuContainer';
import { CreateLobbyComponent, CustomMapProps } from './CreateLobbyComponent';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { createTournament, toMiliSTX } from '../../auth';
import $ from 'jquery';
import {
  createStraight,
  createTwisty,
  getNumberOfCarsForLength,
} from '../../game-engine/maps-utils/custom-lobby/generate-road';
import { contractMapping } from '../../constants/contract';
import { network } from '../../constants/network';
import { DialogTitleHighscores } from '../highscores/components/DialogTitleCustom';
import { transactionUrl } from '../../constants/transactionUrl';
import { link_comp } from '../../game-engine/maps-utils/constants';

export interface ICreateLobbyProps {
  onClickBack: () => void;
  accountAddress: string;
  accountAddressShort: string;
}

export type LoadingState = 'Failed' | 'Successful' | 'Loading' | 'None' | 'Canceled' | 'ParametersInvalid';
export type OpenState = true | false;

export const CreateLobby = (props: ICreateLobbyProps) => {
  const { accountAddress, accountAddressShort, onClickBack } = props;

  const [customGameProps, setCustomGameProps] = useState<CustomMapProps>({
    map: 'bigApple',
    length: 'normal',
    traffic: 'usual',
    curves: 'twisty',
    price: 5,
    hours: 24,
    // privacy: 'public',
    description: 'new lobby description',
    cars: 0,
    road: [],
  });
  const [loadingState, setLoadingState] = useState<LoadingState>('None');
  const [open, setOpen] = useState<OpenState>(true);

  const sendDbNewLobby = (txId: any, cars: number, road: Array<number>) => {
    const userDt = localStorage.getItem('userData');
    if (userDt == null) return;
    const owner = JSON.parse(userDt);

    $.post(
      link_comp + '/new-lobby',
      {
        owner: owner,
        // privacy: customGameProps.privacy,
        description: customGameProps.description,
        price: customGameProps.price,
        hours: customGameProps.hours,
        map: customGameProps.map,
        length: customGameProps.length,
        traffic: customGameProps.traffic,
        curves: customGameProps.curves,
        cars: cars,
        road: road,
        txId: txId,
      },
      () => {
        setLoadingState('Successful');
      }
    ).fail((xhr) => {
      if (JSON.parse(xhr.responseText).message === 'creationFailed') setLoadingState('Failed');
    });
  };

  const setCancelState = () => {
    setLoadingState('Canceled');
  };

  // TODO(#44): create visitor pattern
  function generateRoad(customGameProps: CustomMapProps) {
    let minLength, maxLength;
    switch (customGameProps.length) {
      case 'normal':
        minLength = 4800;
        maxLength = 6400;
        break;
      case 'long':
        minLength = 7400; // ~800 is added after
        maxLength = 9600;
    }
    let roadInfo;
    let generatedRoad: Array<number> = [],
      roadLength: number = 0;
    if (customGameProps.curves == 'straight') roadInfo = createStraight(minLength, maxLength);
    if (customGameProps.curves == 'twisty') roadInfo = createTwisty(minLength, maxLength);
    if (roadInfo != undefined) {
      generatedRoad = roadInfo.road;
      roadLength = roadInfo.roadLength;
    }

    let generatedCars = getNumberOfCarsForLength(minLength, customGameProps.traffic, roadLength) | 0;
    console.log(customGameProps.traffic);
    return { generatedCars, generatedRoad };
  }

  function lobbyHasCorrectParameters(customGameProps: CustomMapProps): boolean {
    if (customGameProps.hours > 48) return false;
    if (customGameProps.price > 5) return false;
    // the other parameters will fail if they are not from the selected ones

    return true;
  }

  const onCreateLobby = useCallback(async () => {
    const canCreateLobby = await fetch(link_comp + '/lobbies-owned/' + accountAddress) // + "/" + localStorage.getItem("collection"))
      .then((res) => res.json())
      .then((data) => {
        return !data.maximumExceed;
      });
    if (canCreateLobby) {
      if (lobbyHasCorrectParameters(customGameProps)) {
        let { generatedCars, generatedRoad } = generateRoad(customGameProps);
        createTournament({
          customGameProps,
          generatedCars,
          generatedRoad,
          onFinish: sendDbNewLobby,
          onCancel: setCancelState,
        });
        setLoadingState('Loading');
      } else {
        setLoadingState('ParametersInvalid');
      }
    } else {
      setLoadingState('Failed');
    }
  }, [customGameProps, setLoadingState]);

  const onCreateLobbyBtc = useCallback(async () => {
    const canCreateLobby = await fetch(link_comp + '/lobbies-owned/' + accountAddress)
      .then((res) => res.json())
      .then((data) => {
        // console.log(data);
        return !data.maximumExceed;
      });
    if (canCreateLobby) {
      if (lobbyHasCorrectParameters(customGameProps)) {
        let { generatedCars, generatedRoad } = generateRoad(customGameProps);

        // @ts-ignore::next-line
        window.lnswap(
          'swap',
          'sdcreategame',
          accountAddress,
          customGameProps.price,
          contractMapping[network].contract,
          '',
          'false',
          '',
          '',
          [
            customGameProps.description,
            toMiliSTX(customGameProps.price),
            3,
            10,
            customGameProps.map,
            customGameProps.length,
            customGameProps.traffic,
            customGameProps.curves,
            customGameProps.hours,
          ]
        );

        // @ts-ignore::next-line
        window.onmessage = function (e) {
          if (e.data?.target === 'lnswap' && e.data?.data.status === 'triggerCreateLobby pending') {
            const txId = e.data.data.txId;
            if (txId === '') setLoadingState('ParametersInvalid');
            else {
              sendDbNewLobby(txId, generatedCars, generatedRoad);
              // console.log('received data onmessage custom from lnswap widget: ', e.data.data);
              console.log(
                `created lobby with btc confirmed. see on explorer: ${transactionUrl[network](txId).explorerUrl}`
              );
            }
          }
        };
      }
    } else {
      setLoadingState('Failed');
    }
  }, [customGameProps, setLoadingState]);

  const handleOpenCreateLobby = () => {
    setOpen(true);
    onCreateLobby();
  };

  const handleOpenCreateLobbyBtc = () => {
    setOpen(true);
    onCreateLobbyBtc();
  };

  const handleClose = () => {
    setOpen(false);
    setLoadingState('None');
  };

  let content = (
    <>
      <CreateLobbyComponent
        accountAddress={accountAddress}
        accountAddressShort={accountAddressShort}
        customGameProps={customGameProps}
        onChangeCustomGameProps={setCustomGameProps}
      />
      <Dialog open={loadingState !== 'None' && open === true} onClose={handleClose} disableEnforceFocus>
        <DialogTitleHighscores id={'state'} onClose={handleClose}>
          {loadingState === 'Successful'
            ? 'Congratulations'
            : loadingState === 'Failed'
            ? 'Failed'
            : loadingState === 'Canceled'
            ? 'Transaction Canceled'
            : loadingState === 'ParametersInvalid'
            ? 'Parameters Invalid'
            : 'Loading...'}
        </DialogTitleHighscores>
        <DialogContent className="main-color">
          {loadingState === 'Successful'
            ? 'Succesfully submitted new lobby creation'
            : loadingState === 'Failed'
            ? 'Maximum number of lobbies created'
            : loadingState === 'Canceled'
            ? 'Create lobby canceled'
            : loadingState === 'ParametersInvalid'
            ? 'Parameters for create lobby are invalid'
            : 'We are creating your lobby, please hang tight!'}
        </DialogContent>
        <DialogActions className="main-color">
          <Button label={'Main Menu'} secondary={true} onClick={onClickBack} />
          <Button label={'Close'} autoFocus secondary={true} onClick={handleClose} />
        </DialogActions>
      </Dialog>
    </>
  );

  const footer = (
    <>
      <Button label={'Back'} secondary={true} onClick={onClickBack} className={'mx-2'} />
      <Button
        label={'Create lobby'}
        secondary={true}
        onClick={handleOpenCreateLobby}
        className={'mx-2'}
        disabled={!loadingState}
      />
      <Button
        label={'Create lobby with btc'}
        secondary={true}
        onClick={handleOpenCreateLobbyBtc}
        className={'mx-2'}
        disabled={!loadingState}
      />
    </>
  );

  return <MenuContainer content={content} footer={footer} />;
};
